export default __webpack_public_path__ + "static/winter18-32c127714b6b628fd1ab243af475ca19.webp";